'use client'

import { useCompany } from '@/shared/hooks/useCompanies'
import { useTranslations } from 'next-intl'
import ClipboardButtonText from './ClipboardButton/ClipboardButtonText'

const CopyCompanyIdButton = () => {
    const company = useCompany()
    const t = useTranslations('root')

    return (
        <ClipboardButtonText
            data-testid="__copy-company-id-button__"
            isLoading={company.isLoading}
            textToCopy={company.data?.id || ''}
        >
            {t('components.topper.actions.copyCompanyId')}
        </ClipboardButtonText>
    )
}

export default CopyCompanyIdButton
